/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_Faq_Q3Inputs */

const en_guide_what_is_json_faq_q3 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the maximum size of a JSON file?`)
};

const ko_guide_what_is_json_faq_q3 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 파일의 최대 크기는 얼마인가요?`)
};

const ja_guide_what_is_json_faq_q3 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONファイルの最大サイズは？`)
};

/**
* | output |
* | --- |
* | "What's the maximum size of a JSON file?" |
*
* @param {Guide_What_Is_Json_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_faq_q3 = /** @type {((inputs?: Guide_What_Is_Json_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_faq_q3(inputs)
	if (locale === "ko") return ko_guide_what_is_json_faq_q3(inputs)
	return ja_guide_what_is_json_faq_q3(inputs)
});